import { addDays } from ".";

function setItem(key, value, customExpiry) {
	let expiry

	if (customExpiry) {
		expiry = customExpiry
	} else {
		const limit = addDays(new Date(), 1)
		limit.setUTCHours(3, 0, 0)
		expiry = limit.getTime()
	}

	const item = {
		value,
		expiry,
	}

	localStorage.setItem(key, JSON.stringify(item))
}

function getItem(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr)

	if (new Date().getTime() > item.expiry) {
		// TODO: Change current timezone
		localStorage.removeItem(key)
		return null
	}

  return item.value;
}

export { setItem, getItem };